import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const GlobalProgramBasicInfoComponent = ({ onInnerBasicFormChange, selectedGlobalPrograms, shippingProviders }: any) => {

    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer

                        label="Enable"
                        name="IsEnabled"
                            isDisabled
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedGlobalPrograms?.IsEnabled}
                    />

                    <InputContainer

                        label="Active"
                        name="IsActive"
                            isDisabled
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsActive'
                            )
                        }}
                        type="checkbox"
                        value={selectedGlobalPrograms?.IsActive}
                    />

                    <InputContainer
                        label="Name"
                        name="Name"
                        isDisabled
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedGlobalPrograms?.Name}
                    />

                    <InputContainer
                        label="Start Date"
                        name="StartDateUtc"
                        isDisabled
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'StartDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedGlobalPrograms?.StartDateUtc}
                    />

                    <InputContainer
                        label="End Date"
                        name="EndDateUtc"
                        isDisabled
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EndDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedGlobalPrograms?.EndDateUtc}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        isDisabled
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedGlobalPrograms?.Description}
                    />

                </div>
            }
            expandedPanel="Basic Info"
            headerTitle="Basic Info"
        />
        </>

    )
}
export default GlobalProgramBasicInfoComponent;
